<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title>
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add Vendor
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="Name *"
                prepend-inner-icon="mdi-account"
                :error-messages="errors.name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.phone"
                outlined
                label="Phone *"
                prepend-inner-icon="mdi-phone"
                :error-messages="errors.phone"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.location"
                outlined
                label="Location"
                prepend-inner-icon="mdi-map-marker"
                :error-messages="errors.location"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.city"
                outlined
                label="City"
                prepend-inner-icon="mdi-city"
                :error-messages="errors.city"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.state"
                outlined
                label="State"
                prepend-inner-icon="mdi-map"
                :error-messages="errors.state"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.pincode"
                outlined
                label="Pincode"
                prepend-inner-icon="mdi-mailbox"
                :error-messages="errors.pincode"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.country"
                outlined
                label="Country"
                prepend-inner-icon="mdi-earth"
                :error-messages="errors.country"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-textarea
                v-model="form.address"
                outlined
                rows="4"
                label="Address *"
                prepend-inner-icon="mdi-map-marker-outline"
                :error-messages="errors.address"
              ></v-textarea>
            </v-col>
            <v-col sm="6">
              <v-textarea
                v-model="form.remarks"
                outlined
                rows="4"
                label="Remarks"
                prepend-inner-icon="mdi-note-text-outline"
                :error-messages="errors.remarks"
              ></v-textarea>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-divider class="mt-5 mb-5"> </v-divider>
          <v-btn
            :loading="isLoading"
            :disabled="isLoading"
            rounded
            color="primary"
            dark
            @click="save"
          >
            Save Vendor
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog v-model="dialogVisible" width="600" height="1000">
      <v-card rounded="xxl">
        <v-container>
          <v-row align="center">
            <v-col sm="3" align="center">
              <v-icon
                large
                style="color: red; font-size: 100px; width: 200px !important"
              >
                mdi-alert-remove-outline
              </v-icon>
            </v-col>
            <v-col sm="9" align="center">
              <v-card-text>
                <v-row>
                  <v-col>
                    <h1 style="color: red">OOPS!</h1>
                    <br />
                    <h3>{{ dialogMessage }}</h3>
                    <br />
                    <v-btn color="red" @click="dialogVisible = false">
                      OK
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "VendorCreatePage",
  data() {
    return {
      form: {
        name: "",
        phone: "",
        location: "",
        address: "",
        city: "",
        state: "",
        pincode: "",
        country: "",
        remarks: "",
        is_active: true,
      },
      dialogVisible: false,
      dialogMessage: "",
      isLoading: false,
      errors: {},
    };
  },
  methods: {
    async save() {
      try {
        this.isLoading = true;
        
        const response = await axios.post("/vendors", this.form);

        // Check if the request was successful based on the response data
        if (response.data.success) {
          console.log("Vendor created successfully", response.data);
          this.$router.push("/vendors");
        } else {
          const errorMessage = response.data.message || "Operation failed";
          this.dialogMessage = errorMessage;
          this.dialogVisible = true;
        }
      } catch (e) {
        // This will catch network errors or HTTP errors (like 400, 500)
        const errorMessage = e.response?.data?.message || "An error occurred";
        console.error("Error creating vendor:", errorMessage);
        this.dialogMessage = errorMessage;
        this.dialogVisible = true;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
